//@flow

import {AuthBloc} from "./authBloc";
import React from "react";
import {ProjectBloc} from "./projectBloc";
import {UserBloc} from "./userBloc";
import ProjectApi from "../api/ProjectApi/ProjectApi";
import ProjectService from "../service/ProjectService/ProjectService";
import UserService from "../service/UserService/UserService";
import UserApi from "../api/UserApi/UserApi";
import TaskGroupApi from "../api/TaskGroupApi/TaskGroupApi";
import TaskGroupService from "../service/TaskGroupService/TaskGroupService";
import TaskService from "../service/TaskService/TaskService";
import TaskApi from "../api/TaskApi/TaskApi";
import {TaskBloc} from "./taskBloc";
import AssignedTaskService from "../service/AssignedTaskService/AssignedTaskService";
import AssignedTaskApi from "../api/AssignedTaskApi/AssignedTaskApi";
import {AssignedTaskBloc} from "./assignedTaskBloc";
import {HomeownerApplicationBloc} from "./homeownerApplicationBloc";
import HomeownerApplicationApi from "../api/HomeownerApplicationApi/HomeownerApplicationApi";
import HomeownerApplicationService from "../service/HomeownerApplicationService/HomeownerApplicationService";
import AttachmentApi from "../api/AttachmentApi/AttachmentApi";
import AttachmentService from "../service/AttachmentService/AttachmentService";
import {AttachmentBloc} from "./projectAttachmentBloc";
import AttachmentStorageApi from "../api/AttachmentApi/AttachmentStorageApi";
import ProjectGroupService from "../service/ProjectGroupService/ProjectGroupService";
import ProjectGroupApi from "../api/ProjectGroupApi/ProjectGroupApi";
import VendorApi from "../api/VendorApi/VendorApi";
import VendorService from "../service/VendorService/VendorService";
import {VendorBloc} from "./vendorBloc";
import { InvoiceBloc } from "./projectInvoiceBloc";
import InvoiceApi from "../api/InvoiceApi/InvoiceApi";
import InvoiceService from "../service/InvoiceService/InvoiceService";
import DonationApi from "../api/DonationApi/DonationApi";
import DonationService from "../service/DonationService/DonationService";
import { ExportErBloc } from "./exportErBloc";
import ExportErApi from "../api/ExportErApi/ExportErApi";
import ExportErService from "../service/ExportErService/ExportErService";
import { NotesBloc } from "./notesBloc";
import NotesService from "../service/NotesService/NotesService";
import NotesApi from "../api/NotesApi/NotesApi";
import TaskListApi from "../api/TaskListApi/TaskListApi";
import TaskListService from "../service/TaskListService/TaskListService";
import BrandApi from "../api/BrandApi/BrandApi";
import BrandService from "../service/BrandService/BrandService";
import {BrandBloc} from "./brandBloc";
import SearchHistoryApi from "../api/SearchHistoryApi/SearchHistoryApi";
import SearchHistoryService from "../service/SearchHistoryService";
import { PaymentBloc } from "./projectPaymentBloc";
import PaymentApi from "../api/PaymentApi/PaymentApi";
import PaymentService from "../service/PaymentService/PaymentService";
class BlocContext {
    authBloc: AuthBloc;
    projectBloc: ProjectBloc;
    userBloc: UserBloc;
    taskBloc: TaskBloc;
    assignedTaskBloc: AssignedTaskBloc;
    homeownerApplicationBloc: HomeownerApplicationBloc;
    attachmentBloc: AttachmentBloc;
    vendorBloc: VendorBloc;
    invoiceBloc: InvoiceBloc;
    paymentBloc: PaymentBloc;
    exportErBloc: ExportErBloc;
    notesBloc: NotesBloc;
    brandBloc: BrandBloc;
    donationService: DonationService;
    searchHistoryService: SearchHistoryService;

    constructor(authBloc: AuthBloc,
        projectBloc: ProjectBloc,
        userBloc: UserBloc,
        taskBloc: TaskBloc,
        assignedTaskBloc: AssignedTaskBloc,
        homeownerApplicationBloc: HomeownerApplicationBloc,
        attachmentBloc: AttachmentBloc,
        vendorBloc: VendorBloc,
        invoiceBloc: InvoiceBloc,
        paymentBloc: PaymentBloc,
        exportErBloc: ExportErBloc,
        notesBloc: NotesBloc,
        brandBloc: BrandBloc,
        donationService: DonationService,
        searchHistoryService: SearchHistoryService) {
        this.authBloc = authBloc;
        this.projectBloc = projectBloc;
        this.userBloc = userBloc;
        this.taskBloc = taskBloc;
        this.assignedTaskBloc = assignedTaskBloc;
        this.homeownerApplicationBloc = homeownerApplicationBloc;
        this.attachmentBloc = attachmentBloc;
        this.vendorBloc = vendorBloc;
        this.invoiceBloc = invoiceBloc;
        this.paymentBloc = paymentBloc;
        this.exportErBloc = exportErBloc;
        this.notesBloc = notesBloc;
        this.brandBloc = brandBloc;
        this.donationService = donationService;
        this.searchHistoryService = searchHistoryService;
    }
}

const authBloc = new AuthBloc();

const projectGroupApi = new ProjectGroupApi(authBloc);
const projectGroupService = new ProjectGroupService(projectGroupApi);

const projectApi = new ProjectApi(authBloc);
const projectService = new ProjectService(projectApi, projectGroupService);

const projectBloc = new ProjectBloc(projectService, projectGroupService, authBloc);

const userApi = new UserApi(authBloc);
const userService = new UserService(userApi);
const userBloc = new UserBloc(userService, authBloc);

const taskApi = new TaskApi(authBloc);
const taskGroupApi = new TaskGroupApi(authBloc);
const taskListApi = new TaskListApi(authBloc);
const taskService = new TaskService(taskApi);
const taskGroupService = new TaskGroupService(taskGroupApi);
const taskListService = new TaskListService(taskListApi);
const taskBloc = new TaskBloc(taskService, taskGroupService, taskListService, authBloc);

const assignedTaskApi = new AssignedTaskApi(authBloc);
const assignedTaskService = new AssignedTaskService(assignedTaskApi);
const assignedTaskBloc = new AssignedTaskBloc(assignedTaskService);

const homeownerApplicationApi = new HomeownerApplicationApi(authBloc);
const homeownerApplicationService = new HomeownerApplicationService(homeownerApplicationApi);
const homeownerApplicationBloc = new HomeownerApplicationBloc(homeownerApplicationService);

const attachmentApi = new AttachmentApi(authBloc);
const attachmentStorageApi = new AttachmentStorageApi();
const attachmentService = new AttachmentService(attachmentApi, attachmentStorageApi);
const attachmentBloc = new AttachmentBloc(attachmentService);

const vendorApi = new VendorApi(authBloc);
const vendorService = new VendorService(vendorApi, attachmentStorageApi);
const vendorBloc = new VendorBloc(vendorService, authBloc);

const invoiceApi = new InvoiceApi(authBloc);
const invoiceService = new InvoiceService(invoiceApi,attachmentStorageApi);
const invoiceBloc = new InvoiceBloc(invoiceService);

const paymentApi = new PaymentApi(authBloc);
const paymentService = new PaymentService(paymentApi, attachmentStorageApi);
const paymentBloc = new PaymentBloc(paymentService);

const donationApi = new DonationApi(authBloc);
const donationService = new DonationService(donationApi, attachmentStorageApi);

const exportErApi = new ExportErApi(authBloc);
const exportErService = new ExportErService(exportErApi);
const exportErBloc = new ExportErBloc(exportErService);

const notesApi = new NotesApi(authBloc);
const noteService = new NotesService(notesApi);
const notesBloc = new NotesBloc(noteService);

const brandApi = new BrandApi(authBloc);
const brandService = new BrandService(brandApi);
const brandBloc = new BrandBloc(brandService);

const searchHistoryApi = new SearchHistoryApi(authBloc);
const searchHistoryService = new SearchHistoryService(searchHistoryApi);

export default React.createContext<BlocContext>(new BlocContext(authBloc,
    projectBloc,
    userBloc,
    taskBloc,
    assignedTaskBloc,
    homeownerApplicationBloc,
    attachmentBloc,
    vendorBloc,
    invoiceBloc,
    paymentBloc,
    exportErBloc,
    notesBloc,
    brandBloc,
    donationService,
    searchHistoryService
));
